import { useState } from "react";
import { TAGS, DAILY_HOUR_LIMIT } from "./constants";
const TimelogModal = ({
  date,
  editingId,
  editData,
  timelogs,
  onClose,
  onSave,
}) => {
  const dayLogs = timelogs.filter(
    (log) => log.date === date && log.type !== "leave" && log.id !== editingId
  );
  const currentHours = dayLogs.reduce((sum, log) => sum + log.duration, 0);
  const remainingHours = DAILY_HOUR_LIMIT - currentHours;

  const [title, setTitle] = useState(editData?.title || "");
  const [duration, setDuration] = useState(editData?.duration || "");
  const [tag, setTag] = useState(editData?.tag || TAGS[0].id);
  const [notes, setNotes] = useState(editData?.notes || "");
  const [error, setError] = useState("");

  const handleSave = () => {
    if (!title.trim() || !duration) {
      setError("Title and duration are required");
      return;
    }

    const durationNum = Number.parseFloat(duration);
    if (durationNum <= 0) {
      setError("Duration must be greater than 0");
      return;
    }

    if (durationNum > remainingHours) {
      setError(`Cannot exceed ${remainingHours.toFixed(1)}h remaining today`);
      return;
    }

    onSave({
      date,
      title: title.trim(),
      duration: durationNum,
      tag,
      notes: notes.trim(),
      type: "timelog",
    });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="w-full max-w-md rounded-lg bg-white p-6 shadow-lg">
        <h2 className="mb-4 text-xl font-bold text-slate-900">
          {editingId ? "Edit Timelog" : "Add Timelog"}
        </h2>
        <p className="mb-4 text-sm text-slate-600">{date}</p>

        {error && (
          <div className="mb-4 rounded-md bg-red-50 p-3 text-sm text-red-700">
            {error}
          </div>
        )}

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700">
              Title <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="What did you work on?"
              className="mt-1 w-full rounded-md border border-slate-300 px-3 py-2 focus:border-blue-500 focus:outline-none"
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-700">
                Duration (h) <span className="text-red-500">*</span>
              </label>
              <input
                type="number"
                min="0.5"
                step="0.5"
                max={remainingHours}
                value={duration}
                onChange={(e) => setDuration(e.target.value)}
                placeholder="0.5"
                className="mt-1 w-full rounded-md border border-slate-300 px-3 py-2 focus:border-blue-500 focus:outline-none"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700">
                Tag
              </label>
              <select
                value={tag}
                onChange={(e) => setTag(e.target.value)}
                className="mt-1 w-full rounded-md border border-slate-300 px-3 py-2 focus:border-blue-500 focus:outline-none"
              >
                {TAGS.map((t) => (
                  <option key={t.id} value={t.id}>
                    {t.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700">
              Notes
            </label>
            <textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Any additional notes..."
              rows="3"
              className="mt-1 w-full rounded-md border border-slate-300 px-3 py-2 focus:border-blue-500 focus:outline-none"
            />
          </div>

          <div className="rounded-md bg-blue-50 p-3 text-sm text-blue-700">
            <div>
              Current: {currentHours.toFixed(1)}h | Remaining:{" "}
              {remainingHours.toFixed(1)}h
            </div>
            <div>Limit: {DAILY_HOUR_LIMIT}h</div>
          </div>
        </div>

        <div className="mt-6 flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 rounded-md border border-slate-300 px-4 py-2 font-medium hover:bg-slate-50"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="flex-1 rounded-md bg-blue-600 px-4 py-2 font-medium text-white hover:bg-blue-700"
          >
            {editingId ? "Update" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};
export default TimelogModal;
